import { render, staticRenderFns } from "./InquiryRegister.vue?vue&type=template&id=7898f536&"
import script from "./InquiryRegister.vue?vue&type=script&lang=js&"
export * from "./InquiryRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InquiryRegister.vue"
export default component.exports